import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FiMenu, FiX } from 'react-icons/fi';

const Sidebar = () => {
  const [isOpen, setIsOpen] = useState(true);
  const location = useLocation();
  const navigate = useNavigate(); // ✅ Added this line
  const toggleSidebar = () => setIsOpen(!isOpen);

  return (
    <aside style={{ ...styles.sidebar, width: isOpen ? '240px' : '72px' }}>
      <div style={styles.topBar}>
        <button onClick={toggleSidebar} style={styles.toggleBtn}>
          {isOpen ? <FiX size={22} /> : <FiMenu size={22} />}
        </button>
        {isOpen && <h2 style={styles.logo}>🌐 Admin</h2>}
      </div>

      <nav style={styles.nav}>
        <NavLink to="/Admin-home" label="Home" icon="🏠" active={location.pathname === '/Admin-home'} isOpen={isOpen} />
        <NavLink to="/addDomastic-tour" label="DomasticTour" icon="➕" active={location.pathname === '/addDomastic-tour'} isOpen={isOpen} />
        <NavLink to="/AddInternational-Tour" label="InternationalTour" icon="🌍" active={location.pathname === '/AddInternational-Tour'} isOpen={isOpen} />
        <NavLink to="/AddGallery" label="Gallery" icon="🖼️" active={location.pathname === '/AddGallery'} isOpen={isOpen} />
        <NavLink to="/AddTestimonials" label="Testimonials" icon="💬" active={location.pathname === '/AddTestimonials'} isOpen={isOpen} />
        <NavLink to="/AddAboutUs" label="AboutUs" icon="💬" active={location.pathname === '/AddAboutUs'} isOpen={isOpen} />
      
        {/* <NavLink to="/AddFooter" label="Footer" icon="🔗" active={location.pathname === '/AddFooter'} isOpen={isOpen} /> */}

        {/* ✅ Register Button Styled Like NavLink */}
        <div
          onClick={() => navigate('/register')}
          style={{
            ...styles.link,
            backgroundColor: '#00b4d8',
            cursor: 'pointer',
            justifyContent: isOpen ? 'flex-start' : 'center',
          }}
        >
          <span style={styles.icon}>📝</span>
          {isOpen && <span>Register</span>}
        </div>
      </nav>
    </aside>
  );
};

const NavLink = ({ to, label, icon, active, isOpen }) => (
  <Link
    to={to}
    style={{
      ...styles.link,
      backgroundColor: active ? '#90e0ef' : '#caf0f8',
      justifyContent: isOpen ? 'flex-start' : 'center',
    }}
  >
    <span style={styles.icon}>{icon}</span>
    {isOpen && <span>{label}</span>}
  </Link>
);

const styles = {
  sidebar: {
    minHeight: '100vh',
    background: 'linear-gradient(to bottom, #023e8a, #0077b6)',
    color: '#fff',
    paddingTop: '20px',
    transition: 'width 0.3s ease',
    position: 'sticky',
    top: 0,
    zIndex: 99,
  },
  topBar: {
    display: 'flex',
    alignItems: 'center',
    padding: '0 12px',
    gap: '10px',
    marginBottom: '30px',
  },
  toggleBtn: {
    background: 'none',
    border: 'none',
    color: '#fff',
    cursor: 'pointer',
  },
  logo: {
    fontSize: '18px',
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
  },
  nav: {
    display: 'flex',
    flexDirection: 'column',
    gap: '14px',
    padding: '0 12px',
  },
  link: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '10px 12px',
    borderRadius: '8px',
    color: '#03045e',
    background: '#caf0f8',
    textDecoration: 'none',
    fontWeight: '600',
    transition: 'all 0.3s ease',
  },
  icon: {
    fontSize: '18px',
  },
};

export default Sidebar;
